module.exports = __webpack_public_path__ + "static/media/Icon-CV_Set 2_Non-Pro.a5d7013e.svg";